export const model = {
    id: null,
    partner_clinic_id: "",
    courier_id: "",
    created_at: '',
    updated_at: ''
};
